import Model from '@/store/model';
import Pricing from './pricing';
import Categories from './categories';
import ExpressionResponse from './expression_response';

class ExpressionTagsResponse extends Model {
  map(json) {
    super.map(json);

    if (json.pricing !== undefined && json.pricing !== null) {
      this.pricing = new Pricing();
      this.pricing.map(json.pricing);
    }

    if (json.categories !== undefined && json.categories !== null) {
      this.mapArray('categories', json.categories, Categories);
    }

    if (json.limited_favourite_expressions !== undefined && json.limited_favourite_expressions !== null) {
      this.mapArray('limitedFavouriteExpressions', json.limited_favourite_expressions, ExpressionResponse);
    }
  }
}
export default ExpressionTagsResponse;
